import type { RouteLocationNormalized } from "vue-router";

// Authentication is handled entirely by App.vue onMounted → initializeMSAL().
// This guard intentionally does nothing — do not add signIn() calls here.
export const routerGuard = (_to: RouteLocationNormalized, _from: RouteLocationNormalized): void => {};
